<script lang="ts">
	import { format } from 'svelte-i18n';
	import { disableWrapperFocus, DashRoomWidget } from '@Shelly/shelly-design-system/index';
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { mapLegacyColorToToken } from 'src/helpers/new-layout-helpers';
	import { getRoomLabelList, getRoomMainLabel } from 'src/helpers/room_label_list_helpers';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
import { rooms } from 'src/stores/lists/rooms';
	import { consumption_device } from 'src/stores/features/consumption';
	import { edit } from 'src/stores/ui/edit_lists';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';

	export let roomWidget;

	$: room = $rooms[roomWidget?.id];
	$: mainSensorStatusStore = room?.main_sensor ? getDeviceStatus(room.main_sensor) : undefined;
	$: mainSensorStatus = mainSensorStatusStore ? $mainSensorStatusStore : undefined;
	$: statusMap =
		room?.main_sensor && mainSensorStatus
			? { [real_id(room.main_sensor)]: mainSensorStatus }
			: {};
	$: labelList = getRoomLabelList(room, statusMap, $consumption_device);

	$: title = !room ? roomWidget?.id : room?.name;
	$: image = room?.image && load_image_from(room?.image);
	$: backgroundColor = !room ? `--color-1` : mapLegacyColorToToken(room?.backgroundColor);

	$: rightLabel = !room
		? {
				value: $format('label_missing_room', {
					default: 'Missing Room',
				}),
				icon: 'fa-light fa-triangle-exclamation',
				backgroundColor: '--color-warning',
			}
		: getRoomMainLabel(room, statusMap)?.[0];
</script>

<div use:disableWrapperFocus>
	<DashRoomWidget
		aria-label="Room Widget Card Example"
		class="cursor-pointer"
		{title}
		{image}
		{backgroundColor}
		parameters={!room || $edit ? [] : labelList}
		{rightLabel}
		on:click
		selected={roomWidget?.id === $sidePanelStateCombined?.id}
	/>
</div>
